(function () {
  const overlay = document.getElementById('SiblingOverlay');
  const image = document.getElementById('SiblingOverlayImage');
  const swatchBar = document.getElementById('SiblingOverlaySwatches');

  if (!overlay || !image || !swatchBar) return;

  function getData() {
    const script = document.getElementById('SiblingProductsData');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch {
      return [];
    }
  }

  function setActiveSwatch(index) {
    swatchBar.querySelectorAll('.sibling-overlay__swatch').forEach((el, i) => {
      el.classList.toggle('active', i === index);
    });
  }

  function changeImage(item, index) {
    image.style.opacity = 0;

    setTimeout(() => {
      image.src = item.image;
      image.alt = item.title;
      image.style.opacity = 1;
      setActiveSwatch(index);
    }, 120);
  }

  function openOverlay() {
    const data = getData();
    if (!data.length) return;

    swatchBar.innerHTML = '';

    data.forEach((item, index) => {
      const swatch = document.createElement('button');
      swatch.className = 'sibling-overlay__swatch';
      swatch.innerHTML = `<img src="${item.image}" alt="${item.title}">`;

      swatch.addEventListener('click', () => {
        changeImage(item, index);
      });

      swatch.addEventListener('dblclick', () => {
        overlay.hidden = true;
        const link = document.querySelector(`.product__siblings a[href="${item.url}"]`);
        if (link) link.click();
        else window.location.href = item.url;
      });

      swatchBar.appendChild(swatch);
    });

    changeImage(data[0], 0);

    overlay.hidden = false;
    document.documentElement.classList.add('overlay-open');
  }

  function closeOverlay() {
    overlay.hidden = true;
    document.documentElement.classList.remove('overlay-open');
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-sibling-overlay]')) {
      openOverlay();
    }

    if (e.target.closest('[data-close-overlay]')) {
      closeOverlay();
    }
  });
})();
